export const GP_SPECIALTY_ID = 37
export const GP_FAMILY_SPECIALTY_ID = 35
export const PSYCHOLOGY_SPECIALTY_ID = 64
export const CLINIC_PSYCHOLOGY_SPECIALTY_ID = 55
export const VETERINARIAN = 55


// WEBPACK FOOTER //
// ./src/constants/db/specialties.js